export default {
  'menu.system': 'System',
  'pages.system.action.column': 'Action',
  'pages.system.action.detail': 'Detail',
  'pages.system.action.edit': 'Edit',
  'pages.system.action.refresh': 'Refresh',
  'pages.system.action.reset': 'Reset',
  'pages.system.config.create': 'Create config',
  'pages.system.config.description': 'Description',
  'pages.system.config.detail': 'Config detail',
  'pages.system.config.edit': 'Edit config',
  'pages.system.config.key': 'Key',
  'pages.system.config.value': 'Value',
  'pages.system.empty.data': 'No data',
  'pages.system.empty.result': 'No result',
  'pages.system.health.basic': 'Basic health',
  'pages.system.health.httpStatus': 'HTTP status',
  'pages.system.health.message': 'Message',
  'pages.system.health.responseTime': 'Response time',
  'pages.system.health.service': 'Service',
  'pages.system.health.status': 'Status',
  'pages.system.health.url': 'URL',
  'pages.system.health.version': 'Version',
  'pages.system.message.saved': 'Done',
  'pages.system.result.key': 'Key',
  'pages.system.result.value': 'Value',
  'pages.system.tab.config': 'Configuration',
  'pages.system.tab.health': 'Health',
  'pages.system.tab.tasks': 'Tasks',
  'pages.system.task.job': 'Job',
  'pages.system.task.mode': 'Mode',
  'pages.system.task.title': 'Trigger task',
  'pages.system.task.trigger': 'Trigger',
  'pages.system.title': 'System',
};
